export type VenueContext = 'scan' | 'report' | 'feed' | 'ticketTypeReport';

export interface Venue {
  name: string;
  timezone?: string;
  context?: VenueContext[];
  parents?: string[];
  continent?: string;
  city?: string;
}

/**
 * Raw venue shape as returned by `GET /venue?version=2`. The geo fields come
 * back PascalCase (`Continent`/`City`), unlike the rest of the payload — see
 * normalizeVenue() in VenueService, which maps this to the internal `Venue`.
 */
export interface ApiVenue {
  name: string;
  timezone?: string;
  context?: VenueContext[];
  parents?: string[];
  Continent?: string;
  City?: string;
}

export interface VenueListExtended {
  key?: 'venueListExtended';
  primaryVenue?: string;
  // Stored venues keep the API's PascalCase geo fields (Continent/City), so the
  // admin reads and writes the same shape the /venue endpoint serves.
  venues: Record<string, ApiVenue>;
}

/** A single venue paired with its API key, as consumed by the UI. */
export interface VenueEntry {
  key: string;
  value: Venue;
}

/**
 * Hierarchical view of the venue list used by the venue selector:
 * continent -> city -> venues. Venues missing continent and/or city are
 * grouped under an "Other" fallback so they remain reachable.
 */
export interface VenueCityGroup {
  city: string;
  venues: VenueEntry[];
}

export interface VenueContinentGroup {
  continent: string;
  cities: VenueCityGroup[];
}

/** Fallback label for venues missing continent or city metadata. */
export const VENUE_OTHER_GROUP = 'Other';
